var CaseTatics = function () { return import('~/pages/system-manage/tatics-manage/case-tatics.vue'); };
export default [
    {
        path: '/tatics-manage/case-tatics',
        name: 'case-tatics',
        component: CaseTatics
    }
];
